<app-base-widget [card]="false" [error]="error" data-cy="geographyChart">
    @if (dataMode !== 'mixed') {
    <span class="remaining-value-text" data-cy="byText">{{byText()}}</span>
    }

    @if (dataMode === 'world') {
    <app-gcm-chart [reflowEvent]="reflowEvent()" [mapChartData]="remainingValueByRegionMap"
        [chartConstructor]="'mapChart'" [chartOptions]="remainingValueByRegionMapChartOptions" [chartStyle]="chartStyle"
        chartType="map"></app-gcm-chart>
    } @else if (dataMode === 'us-only') {
    <app-gcm-chart [mapChartData]="usMapData" [chartConstructor]="'mapChart'" [chartOptions]="usMapChartOptions"
        [chartStyle]="chartStyle" [reflowEvent]="reflowEvent()" chartType="map"></app-gcm-chart>
    } @else {
    <!-- mixed: pie (1/3) + US map (2/3) with individual labels -->
    <div class="flex w-full">
        <div class="w-2/5 pt-2">
            <span class="remaining-value-text text-center" data-cy="geoDiversificationText">Geographic Diversification
                by Remaining Value</span>
            <app-gcm-chart [chartData]="pieData" chartType="pie" [chartOptions]="pieChartOptions"
                [chartStyle]="chartStyle" [reflowEvent]="reflowEvent()"></app-gcm-chart>
            @if (otherCountryNames().length > 0) {
            <div class="flex justify-center">
                <p class="text-xs text-charcoal-grey px-5" data-cy="othersBreakdown"><span class="font-semibold">Other includes: </span>
                    <span [innerHTML]="otherCountryNames().join(', ')"></span>
                </p>
            </div>

            }
        </div>
        <div class="w-3/5 pt-2">
            <span class="remaining-value-text text-center" data-cy="usRegionalDiversificationText">U.S. Regional
                Diversification by Remaining Value</span>
            <app-gcm-chart [mapChartData]="usMapData" [chartConstructor]="'mapChart'" [chartOptions]="usMapChartOptions"
                [chartStyle]="chartStyle" [reflowEvent]="reflowEvent()" chartType="map"></app-gcm-chart>
        </div>
    </div>
    }
</app-base-widget>